import { useMutation, useQuery, useQueryClient } from "react-query";
import {
  createGroup,
  deleteGroup,
  fetchGroup,
  fetchGroupsByOrganisationId,
  updateUserGroup,
} from "../api/GroupApi";
// import * as api from "../api/UserApi";

//--- get all grup by ID ---//
export const GetUserGroupById = (groupId) => {
  const queryClient = useQueryClient();
  return useQuery(["group", groupId], fetchGroup, {
    initialData: () => {
      const group = queryClient
        .getQueryData("group")
        ?.data?.find((group) => group.id === parseInt(groupId));
      if (group) {
        return {
          data: group,
        };
      } else {
        return undefined;
      }
    },
  });
};

//--- Create group  ---//
export const CreateGroup = (options) => {
  const queryClient = useQueryClient();

  return useMutation((newUser) => createGroup(newUser), {
    onSuccess: (newUser) => {
      queryClient.invalidateQueries(["groups"]);

      if (options?.onSuccess) options.onSuccess(newUser);
    },
    onError: options?.onError,
  });
};

//--- get all documents by ID ---//
export const GetUserGroupsByOrganisationId = (organisationId) => {
  const queryClient = useQueryClient();
  return useQuery(["groups", organisationId], fetchGroupsByOrganisationId, {
    enabled: !!organisationId,
    initialData: () => {
      const groups = queryClient
        .getQueryData("groups")
        ?.data?.find((document) => document.id === parseInt(organisationId));
      if (groups) {
        return {
          data: groups,
        };
      } else {
        return undefined;
      }
    },
  });
};

//--- Update UserGroup ---//
export const UpdateUserGroup = (options) => {
  const queryClient = useQueryClient();

  return useMutation(
    ({ groupId, groupData, organisationId }) => updateUserGroup(groupId, groupData),
    {
      onSuccess: (data, variables, context) => {
        const orgId = 
          variables.organisationId ||
          data?.data?.organisation_id || 
          variables.groupData?.organisation_id;
        
        if (orgId) {
          queryClient.invalidateQueries(["groups", orgId]);
        } else {
          queryClient.invalidateQueries(["groups"]);
        }
        queryClient.invalidateQueries(["group", variables.groupId]);
        
        if (options?.onSuccess) {
          options.onSuccess(data, variables, context);
        }
      },
      onError: options?.onError,
    }
  );
};

export const DeleteGroup = (options) => {
  const queryClient = useQueryClient();

  return useMutation(
    async (groupId) => {
      if (!groupId) {
        throw new Error("Group ID is required to delete a group.");
      }
      return await deleteGroup(groupId);
    },
    {
      onSuccess: (data, groupId) => {
        queryClient.invalidateQueries(["groups"]);
        if (options?.onSuccess) {
          options.onSuccess(data);
        }
      },
      onError: options?.onError,
    }
  );
};
